import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';
import { isDocumentSubCategory } from '../../enums/document-category.const';

export type LinkedTargetOption = { id: string; label: string };

type LinkedTargetOptionsResponse = { options: LinkedTargetOption[] };

export const useLinkedTargetOptions = (
  companyId: string | undefined,
  subCategory: string | undefined,
) => {
  const resolvedSubCategory =
    subCategory != null && isDocumentSubCategory(subCategory) ? subCategory : undefined;
  const enabled = companyId != null && resolvedSubCategory != null;

  const { data, isLoading } = useAppQuery<LinkedTargetOptionsResponse>({
    enabled,
    queryFn: () =>
      ApiService.get<LinkedTargetOptionsResponse>(
        { endpoint: BackendRoute.SIGNATURES_LINKED_TARGET_OPTIONS },
        { queryParams: { subCategory: resolvedSubCategory! } },
      ),
    queryKey: [QueryKey.SIGNATURES_LINKED_TARGET_OPTIONS, companyId, resolvedSubCategory],
  });

  return {
    isLoading: enabled && isLoading,
    options: data?.options ?? [],
  };
};
